import PLANTILLA_POR_MODULO from '@/graphql/querys/administracion/configuracion/plantillas/plantillaPorModulo.gql';
import CONCEPTOS_EXCEDENTES from '@/graphql/querys/administracion/contratos/catalogoConceptos/conceptosExcedentes.gql';
import mixFormatoEstructura from '@/helpers/mixFormatoEstructura';
import mixGenerarPlantilla from '@/helpers/mixGenerarPlantilla';

export default {
  mixins: [mixFormatoEstructura, mixGenerarPlantilla],
  data() {
    return {
      seleccionaEstimacion: null,
      seleccionaContrato: null,
      estimacionCompleta: {},
      getConceptosExcedentes: false,
      plantilla: Object,
      plantillaBusca: '',
      nombreArchivo: '',
      mostrarLoading: null,
      modulo: 'ejecucion',
    };
  },
  apollo: {
    plantillaPorModulo: {
      query: PLANTILLA_POR_MODULO,
      variables() {
        return {
          modulo: this.modulo,
        };
      },
    },
  },
  methods: {
    async getDatos() {
      const { data } = await this.$apollo.query({
        query: CONCEPTOS_EXCEDENTES,
        variables: {
          idEstimacion: this.seleccionaEstimacion,
          idContrato: this.seleccionaContrato,
        },
        fetchPolicy: 'network-only',
      });
      const ubicacion = {
        localidad: this.contrato?.obras[0]?.obra.ubicacion.localidad || '',
        municipio: this.contrato?.obras[0]?.obra.ubicacion.municipio.nombre || '',
      };
      const contratista = {
        nombreRazonSocial: this.contrato?.contratista.nombreRazonSocial || '',
        nombreRepresentante: this.contrato?.contratista.nombreRepresentante || '',
      };
      const conceptosExcedentes = data?.conceptosExcedentes || [];
      const contratoResidente = this.contrato?.responsables.filter((r) => r.principal === true)[0]
        ? this.contrato?.responsables
          .filter((r) => r.principal === true)
          .map((r) => r.funcionario.nombre)[0]
        : '';
      const datos = {
        contrato_objeto: this.contrato?.meta || '',
        contrato_numero: this.contrato?.numero,
        estimacion_numero: this.estimacionCompleta.numero,
        contratista,
        ubicacion,
        contrato_residente: contratoResidente,
        conceptos_excedentes: conceptosExcedentes,
      };
      return datos;
    },
    // Llama a mixGenerarPlantilla del microservicio de word
    async generaWord() {
      this.mostrarLoading = true;
      const datosConFormato = await this.getDatos();
      const nombrePlantilla = this.plantilla.path;
      const nombreArchivoGenerado = `JUSTIFICACION_CONCEPTOS_EXCEDENTES_${this.contrato.numero}_${this.estimacionCompleta.numero}`;
      await this.mixGenerarPlantilla(
        {
          data: {
            plantilla: nombrePlantilla,
            datos: datosConFormato,
          },
        },
        nombreArchivoGenerado,
      );
      this.mostrarLoading = null;
    },
    seleccionarPlantilla(estimacion) {
      this.estimacionCompleta = estimacion;
      this.seleccionaEstimacion = estimacion.id;
      this.seleccionaContrato = estimacion.idContrato;
      this.plantillaBusca = 'JUSTIFICACION CONCEPTOS EXCEDENTES';
      if (Object.keys(this.getPlantilla).length > 0) {
        this.plantilla = this.getPlantilla;
        this.generaWord();
      }
    },
  },
  computed: {
    getPlantilla() {
      if (!this.plantillaPorModulo || this.plantillaBusca === '') {
        return [];
      }
      return (
        this.plantillaPorModulo
          .slice()
          .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
          .find((p) => p.nombre.toUpperCase().includes(this.plantillaBusca.toUpperCase())) || {}
      );
    },
  },
};
